document.addEventListener('DOMContentLoaded', function(){
  var root = document.getElementById('fnsse-sf');
  if(!root) return;
  var hS = root.querySelector('#sf-hslider'), hOut = root.querySelector('#sf-h');
  var wS = root.querySelector('#sf-wslider'), wOut = root.querySelector('#sf-w');
  var hint = root.querySelector('#sf-hint');
  var go = root.querySelector('#sf-go');
  var reveal = root.querySelector('#sf-reveal');
  var sizeEl = root.querySelector('#sf-size'), tagEl = root.querySelector('#sf-tag');
  var specs = root.querySelector('#sf-specs'), burst = root.querySelector('#sf-burst');
  var fit = 0;

  var DATA = { S:{w:64,l:64,s:57}, M:{w:66,l:65,s:60}, L:{w:69,l:67,s:62}, XL:{w:71,l:69,s:65} };
  var ORDER = ['S','M','L','XL'];

  function fill(el){ el.style.setProperty('--fill', (el.value-el.min)/(el.max-el.min)*100 + '%'); }
  function band(h){ if(h<=172)return 0; if(h<=182)return 1; if(h<=190)return 2; return 3; }

  function compute(){
    var h = +hS.value, kg = +wS.value;
    var idx = band(h);
    var bmi = kg / Math.pow(h/100, 2);
    if(bmi >= 27) idx += 1;
    idx += fit;
    idx = Math.max(0, Math.min(ORDER.length-1, idx));
    return ORDER[idx];
  }

  hS.addEventListener('input', function(){ hOut.textContent = hS.value; fill(hS); });
  wS.addEventListener('input', function(){ wOut.textContent = wS.value; fill(wS); });

  root.querySelectorAll('.sf-pill').forEach(function(p, i){
    p.setAttribute('data-fit', i);
    p.addEventListener('click', function(){
      root.querySelectorAll('.sf-pill').forEach(function(x){ x.classList.remove('is-on'); });
      p.classList.add('is-on'); fit = +p.getAttribute('data-fit');
      hint.textContent = fit ? 'rozmiar wyżej — mocniejszy, workowaty oversize.' : 'leży zgodnie z tabelą — boxy, oversize.';
    });
  });

  function doBurst(){
    burst.innerHTML = '';
    for(var i=0;i<16;i++){
      var d = document.createElement('span'); d.className='sf-dot';
      var ang = Math.random()*Math.PI*2, dist = 40 + Math.random()*70;
      d.style.setProperty('--tx', Math.cos(ang)*dist + 'px');
      d.style.setProperty('--ty', Math.sin(ang)*dist + 'px');
      d.style.background = Math.random() > .5 ? '#FF00B7' : '#0e0e0e';
      d.style.animationDelay = (Math.random()*.08) + 's';
      burst.appendChild(d);
    }
  }

  go.addEventListener('click', function(){
    var size = compute(), d = DATA[size];
    sizeEl.textContent = size;
    tagEl.textContent = fit ? 'większy vibe. tak jak chciałeś.' : 'leży jak ma leżeć.';
    specs.innerHTML = '<div>szer<b>'+d.w+'</b></div><div>dł<b>'+d.l+'</b></div><div>rękaw<b>'+d.s+'</b></div>';
    reveal.classList.remove('show'); void reveal.offsetWidth; reveal.classList.add('show');
    doBurst();
    if(navigator.vibrate) navigator.vibrate(18);
    reveal.scrollIntoView({behavior:'smooth', block:'nearest'});
  });

  fill(hS); fill(wS);
});